import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    coreValuesWinnerList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    currentMonth: {
		requesting: false,
        items: [],
        month_label: "",
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
	},
    previousMonth: {
		requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
	},
  };

export const coreValuesWinnerSlice = createSlice({
  name: 'coreValuesWinner',
  initialState,
  reducers: {
    getCoreValuesWinnerList: (state, action) => {
        state.coreValuesWinnerList.requesting = true;
        state.coreValuesWinnerList.error = null;
        state.coreValuesWinnerList.items = [];
        state.coreValuesWinnerList.success = false;
        state.coreValuesWinnerList.filters = action.payload;
    },
    getCoreValuesWinnerListSuccess: (state, action) => {
        const { data, current_page, per_page, total} = action.payload;
        state.coreValuesWinnerList.requesting = false;        
        state.coreValuesWinnerList.items = data;
        state.coreValuesWinnerList.success = true; 
        state.coreValuesWinnerList.pagination.current_page = current_page;
        state.coreValuesWinnerList.pagination.per_page = per_page;
        state.coreValuesWinnerList.pagination.total = total;
    },
    getCoreValuesWinnerListFail: (state, action) => {        
        state.coreValuesWinnerList.requesting = false;
        state.coreValuesWinnerList.error = action.payload;
    },

    getCurrentMonthList: (state, action) => {
        state.currentMonth.requesting = true;
        state.currentMonth.error = null;
        state.currentMonth.items = [];
        state.currentMonth.success = false;
        state.currentMonth.filters = action.payload;
    },
    getCurrentMonthListSuccess: (state, action) => {
        const response = action.payload;
        state.currentMonth.requesting = false;        
        state.currentMonth.items = response?.data  ?? [];
        state.currentMonth.month_label = response?.month_label ?? "";
        state.currentMonth.success = true; 
        state.currentMonth.pagination.current_page = response?.current_page;
        state.currentMonth.pagination.per_page = response?.per_page;
        state.currentMonth.pagination.total = response?.total;
    },
    getCurrentMonthListFail: (state, action) => {        
        state.currentMonth.requesting = false;
        state.currentMonth.error = action.payload;
    },

    getPreviousMonthList: (state, action) => {
        state.previousMonth.requesting = true;
        state.previousMonth.error = null;
        state.previousMonth.items = [];
        state.previousMonth.success = false;
        state.previousMonth.filters = action.payload;
    },
    getPreviousMonthListSuccess: (state, action) => {
        const response = action.payload;
        state.previousMonth.requesting = false;        
        state.previousMonth.items = response  ?? [];
        state.previousMonth.success = true; 
        state.previousMonth.pagination.current_page = response?.current_page;
        state.previousMonth.pagination.per_page = response?.per_page;
        state.previousMonth.pagination.total = response?.total;
    },
    getPreviousMonthListFail: (state, action) => {        
        state.previousMonth.requesting = false;
        state.previousMonth.error = action.payload;
    },
  },
})

export const { 
    getCoreValuesWinnerList, getCoreValuesWinnerListSuccess, getCoreValuesWinnerListFail,
    getCurrentMonthList, getCurrentMonthListSuccess, getCurrentMonthListFail,
    getPreviousMonthList, getPreviousMonthListSuccess, getPreviousMonthListFail
} = coreValuesWinnerSlice.actions;

export default coreValuesWinnerSlice.reducer;
